import React from "react"
import { APIResponse } from "redux/apis/types"
import APIs from "redux/apis"
import { CreateColumnsType, tableColumns } from "config/table_columns"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { checkIsSp } from "utils/util"

const isSp = checkIsSp()

/************
 *国内株＞IPO
 ***********/

export const ipoDataCategory = [
  {
    id: 0,
    name: "本日公開",
    list: [tableColumns.data.ipoDetail("本日公開")],
    mergeParam: {
      _where: "ListedExchangeDivisionsCount=0 AND SortID=0",
    },
  },
  {
    id: 1,
    name: "公開予定",
    list: [tableColumns.data.ipoDetail("公開予定日")],
    mergeParam: {
      _where: "ListedExchangeDivisionsCount=0 AND SortID=1",
    },
  },
  {
    id: 2,
    name: "公開済",
    list: [tableColumns.data.ipoDetail("公開日")],
    mergeParam: {
      _where: "ListedExchangeDivisionsCount=0 AND SortID=2",
    },
  },
]

export const callIpoApi = async (
  requestParam: object,
  setData: Function,
  loadResistId: string
) => {
  store.dispatch(pageLoadRegist(loadResistId, true))
  const apiRes: APIResponse.Res = await APIs.ChangedSymbol.IPOSymbol(
    requestParam
  )
  setData(apiRes)
  store.dispatch(pageLoadRegist(loadResistId, false))
}

/****************
 *国内株＞銘柄情報
 ***************/
export type ItemToCreateData = {
  data: Array<APIResponse.Res> | []
  setData: Function
  activeLabel: number
  changeLabel: Function
  currentPage: number
  changePage: Function
  currentCategory: object
  changeCategory: Function
}

export const callDataApi = async (
  requestApi: Function,
  param: object,
  setData: Function,
  loadResistId: string
) => {
  store.dispatch(pageLoadRegist(loadResistId, true))
  const apiRes = await requestApi(param)
  setData(apiRes)
  store.dispatch(pageLoadRegist(loadResistId, false))
}

type DataCategoriesType = {
  [t: string]: Array<{
    id: number
    name: string
    list: Array<CreateColumnsType> | Array<Array<object>>
    requestApi: Function
    requestContent?: string
    mergeParam: object
  }>
}

export const DataCategory: DataCategoriesType = {
  ipo: [
    {
      id: 0,
      name: "追加上場",
      list: isSp
        ? [
            tableColumns.data.additionalListingSp.header,
            tableColumns.data.additionalListingSp.body,
          ]
        : [tableColumns.data.additionalListing("上場日")],
      requestApi: APIs.ChangedSymbol.IPOSymbol,
      mergeParam: { _where: "ListedExchangeDivisionsCount>0" },
    },
    {
      id: 1,
      name: "上場廃止",
      list: isSp
        ? [
            tableColumns.data.deListingSp.header,
            tableColumns.data.deListingSp.body,
          ]
        : [tableColumns.data.deListing("廃止予定日")],
      requestApi: APIs.ChangedSymbol.ListingSuspensionSymbol,
      mergeParam: {},
    },
    {
      id: 2,
      name: "指定替え",
      list: isSp
        ? [
            tableColumns.data.changeListingSp.header,
            tableColumns.data.changeListingSp.body,
          ]
        : [tableColumns.data.changeListing("変更日")],
      requestApi: APIs.ChangedSymbol.ChangedListingSymbol,
      mergeParam: {},
    },
  ],
  split: [
    {
      id: 0,
      name: "すべて",
      requestApi: APIs.ChangedSymbol.ChangedCapitalSymbol,
      list: isSp
        ? [
            tableColumns.data.splitAllSp.header,
            tableColumns.data.splitAllSp.body,
          ]
        : [tableColumns.data.splitAll],
      mergeParam: {},
    },
    {
      id: 1,
      name: "株式分割",
      requestApi: APIs.ChangedSymbol.ChangedCapitalSymbol,
      list: isSp
        ? [tableColumns.data.splitSp.header, tableColumns.data.splitSp.body]
        : [tableColumns.data.split],
      mergeParam: { _where: "ChangedContents='分割'" },
    },
    {
      id: 2,
      name: "株式併合",
      requestApi: APIs.ChangedSymbol.ChangedCapitalSymbol,
      list: isSp
        ? [tableColumns.data.splitSp.header, tableColumns.data.splitSp.body]
        : [tableColumns.data.split],
      mergeParam: { _where: "ChangedContents='併合'" },
    },
    {
      id: 3,
      name: "株主割当",
      requestApi: APIs.ChangedSymbol.ChangedCapitalSymbol,
      list: isSp
        ? [tableColumns.data.splitSp.header, tableColumns.data.splitSp.body]
        : [tableColumns.data.split],
      mergeParam: { _where: "ChangedContents='株主割当'" },
    },
  ],
  open: [
    {
      id: 0,
      name: "すべて",
      requestApi: APIs.ChangedSymbol.ChangedFinanceSymbol,
      list: isSp
        ? [
            tableColumns.data.openInfoAllSp.header,
            tableColumns.data.openInfoAllSp.body,
          ]
        : [tableColumns.data.openInfoAll],
      mergeParam: {},
    },
    {
      id: 1,
      name: "公募情報",
      requestApi: APIs.ChangedSymbol.ChangedFinanceSymbol,
      list: isSp
        ? [
            tableColumns.data.openInfoSp.header,
            tableColumns.data.openInfoSp.body,
          ]
        : [tableColumns.data.openInfo],
      requestContent: "公募",
      mergeParam: { _where: "FinanceType='公募'" },
    },
    {
      id: 2,
      name: "第三者割当",
      requestApi: APIs.ChangedSymbol.ChangedFinanceSymbol,
      list: isSp
        ? [
            tableColumns.data.openInfoSp.header,
            tableColumns.data.openInfoSp.body,
          ]
        : [tableColumns.data.openInfo],
      requestContent: "第三者割当",
      mergeParam: {
        _where: "FinanceType='第三者割当'",
        _orderBy: "ApplyDayTo desc",
      },
    },
    {
      id: 3,
      name: "CB発行",
      requestApi: APIs.ChangedSymbol.ChangedFinanceSymbol,
      list: isSp
        ? [
            tableColumns.data.openInfoSp.header,
            tableColumns.data.openInfoSp.body,
          ]
        : [tableColumns.data.openInfo],
      requestContent: "CB発行",
      mergeParam: { _where: "FinanceType='CB発行'" },
    },
    {
      id: 4,
      name: "売り出し",
      requestApi: APIs.ChangedSymbol.ChangedFinanceSymbol,
      list: isSp
        ? [
            tableColumns.data.openInfoSp.header,
            tableColumns.data.openInfoSp.body,
          ]
        : [tableColumns.data.openInfo],
      requestContent: "売り出し",
      mergeParam: { _where: "FinanceType='売り出し'" },
    },
    {
      id: 5,
      name: "株主割当(有償)",
      requestApi: APIs.ChangedSymbol.ChangedFinanceSymbol,
      list: isSp
        ? [
            tableColumns.data.openInfoSp.header,
            tableColumns.data.openInfoSp.body,
          ]
        : [tableColumns.data.openInfo],
      requestContent: "株主割当",
      mergeParam: { _where: "FinanceType='株主割当'" },
    },
  ],
  merge: [
    {
      id: 0,
      name: "合併",
      list: isSp
        ? [tableColumns.data.mergeSp.header, tableColumns.data.mergeSp.body]
        : [tableColumns.data.merge],
      requestApi: APIs.ChangedSymbol.NewMergeredSymbol,
      mergeParam: {},
    },
    {
      id: 1,
      name: "株式交換/移転",
      list: isSp
        ? [tableColumns.data.changeSp.header, tableColumns.data.changeSp.body]
        : [tableColumns.data.change],
      requestApi: APIs.ChangedSymbol.StockExchangeTransfer,
      mergeParam: {},
    },
  ],
  brandChangeLabel: [
    {
      id: 0,
      name: "単位株数変更",
      list: isSp
        ? [tableColumns.data.brandSp.header, tableColumns.data.brandSp.body]
        : [tableColumns.data.brand],
      requestApi: APIs.ChangedSymbol.ChangedUnitSymbol,
      mergeParam: {},
    },
    {
      id: 1,
      name: "商号変更",
      list: isSp
        ? [
            tableColumns.data.tradeNameSp.header,
            tableColumns.data.tradeNameSp.body,
          ]
        : [tableColumns.data.tradeName],
      requestApi: APIs.ChangedSymbol.ChangedBusinessNameSymbol,
      mergeParam: {},
    },
    {
      id: 2,
      name: "安定操作",
      list: isSp
        ? [tableColumns.data.stableSp.header, tableColumns.data.stableSp.body]
        : [tableColumns.data.stable],
      requestApi: APIs.ChangedSymbol.StableSymbol,
      mergeParam: {},
    },
  ],
  Supervision: [
    {
      id: 0,
      name: "監理",
      list: isSp
        ? [
            tableColumns.data.supervisionSp.header,
            tableColumns.data.supervisionSp.body,
          ]
        : [tableColumns.data.supervision],
      requestApi: APIs.ChangedSymbol.SupervisionSymbol,
      mergeParam: {},
    },
    {
      id: 1,
      name: "整理",
      list: isSp
        ? [
            tableColumns.data.organizeSp.header,
            tableColumns.data.organizeSp.body,
          ]
        : [tableColumns.data.organize],
      requestApi: APIs.ChangedSymbol.DelistedSymbol,
      mergeParam: {},
    },
  ],
}
